// extracted by mini-css-extract-plugin
module.exports = {"detail":"video_detail_detail__2FJfj","description":"video_detail_description__3EejG"};